import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import api from "@/lib/api";

export default function PublicLayout() {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    api.get("/public/settings").then((r) => setSettings(r.data || {})).catch(() => {});
  }, []);
  return (
    <div className="site-public flex min-h-screen flex-col">
      <ScrollToTop />
      <Header settings={settings} />
      <main className="flex-1">
        <Outlet context={{ settings }} />
      </main>
      <Footer settings={settings} />
    </div>
  );
}
